import React, { Component } from "react";

import Colorer from "color";
import styled from "styled-components";
import { ProductContext } from '../context'

import ColorThemer, { colorRotater } from './ColorThemer'

import { ColorRandomizerButton } from './ColorRandomizerButton'


export default function ColorRandomizer({
  height = 44,
  handleChange,
  target = 'global',
}) {

  const oldTheme = (target === 'global')
  ? React.useContext(ProductContext).getTheme() :
  React.useContext(ProductContext).sections[target]['theme'];
  const changeTheme = React.useContext(ProductContext).changeTheme;

  const [stateTheme, setStateTheme] = React.useState({
    ...React.useContext(ProductContext).getTheme()
  });

  const [state, setState] = React.useState({
    rotating: false, //needed for animation of the trigger
    scaling: 1
  });

  const timeout = null;




  const setColorRotate = (newAngle, e, saveOrNot) => {

    if (handleChange) {
      handleChange(colorRotater(oldTheme))
    } else {
      changeTheme(target, colorRotater(oldTheme))
    }


    if (timeout) clearTimeout(timeout);
    if (state.scaling !== 0.7) {
    setState({
      ...state,
      rotating: Number(state.rotating) + 180,
      scaling: 0.7
    });
    const timeout = setTimeout(() => {
      // setGlobalColors('rotate', newAngle, saveOrNot);
      setState({
        ...state,
        colorAngle: newAngle,
        rotating: state.rotating + 180,
        scaling: 1
      });
    }, 100);
    }
  };

  return (
    <div>

{oldTheme && <ColorRandomizerButton

  height = {height}
  theme={oldTheme}
  handleChange = {(rotating = 29)=> {
    setStateTheme({
      ...state,
      // rotating:  e.nativeEvent.clientX
      rotating: rotating + 20,
      color: Colorer("red")
        .rgb()
        .rotate(rotating + 20)
        .negate()
        .hex()
    });
    setColorRotate(29)
  }}
/>}
    </div>
  );
}
